import { type AnyIcon } from '@components/icon/Icon';

export type ServiceStatus = keyof typeof SERVICE_STATUS_LABELS;

export const isStatusVisible = (serviceStatus: ServiceStatus): boolean => {
  return !['autoResolved', 'canceled', 'noShow', 'seated'].includes(
    serviceStatus,
  );
};

export const SERVICE_STATUS_LABELS = {
  admitted: 'Admitted',
  appetizer: 'Appetizer',
  arrived: 'Arrived',
  autoResolved: 'Auto Resolved',
  booked: 'Booked',
  bottleService: 'Bottle Service',
  bussingNeeded: 'Bussing Needed',
  canceled: 'Canceled',
  checkDropped: 'Check Dropped',
  cleared: 'Cleared',
  confirmed: 'Confirmed',
  dessert: 'Dessert',
  drinks: 'Drinks',
  entree: 'Entree',
  finished: 'Finished',
  leftMessage: 'Left Message',
  noAnswer: 'No Answer',
  noShow: 'No Show',
  onTheWay: 'On The Way',
  paid: 'Paid',
  partiallyArrived: 'Partially Arrived',
  partiallySeated: 'Partially Seated',
  postMealDrink: 'Post Meal Drink',
  runningLate: 'Running Late',
  seated: 'Seated',
  tableKnock: 'Table Knock',
  tableReady: 'Table Ready',
  unconfirmed: 'Unconfirmed',
  wrongNumber: 'Wrong Number',
} as const satisfies Partial<Record<AnyIcon, string>>;

// These colors are extracted from the various SVG files' fill/stroke values
export const SERVICE_STATUS_COLORS = {
  admitted: '#2F5BE1',
  appetizer: '#AA4DBF',
  arrived: '#2F5BE1',
  autoResolved: '#84B14A',
  booked: '#404C60',
  bottleService: '#AA4DBF',
  bussingNeeded: '#2BA18D',
  canceled: '#DB5C67',
  checkDropped: '#2BA18D',
  cleared: '#2BA18D',
  confirmed: '#404C60',
  dessert: '#AA4DBF',
  drinks: '#AA4DBF',
  entree: '#AA4DBF',
  leftMessage: '#404C60',
  noAnswer: '#404C60',
  onTheWay: '#2F5BE1',
  noShow: '#DB5C67',
  paid: '#2BA18D',
  partiallyArrived: '#2F5BE1',
  partiallySeated: '#E97407',
  postMealDrink: '#AA4DBF',
  runningLate: '#2F5BE1',
  seated: '#E97407',
  tableKnock: '#2BA18D',
  tableReady: '#2F5BE1',
  unconfirmed: '#5D6168',
  wrongNumber: '#404C60',
  finished: '#84B14A',
} as const satisfies Partial<Record<AnyIcon, string>>;

// these are in display order...India 👀
export const SERVICE_STATUS_SELECTION_LIST = [
  'unconfirmed',
  'booked',
  'leftMessage',
  'wrongNumber',
  'noAnswer',
  'confirmed',
  'onTheWay',
  'runningLate',
  'arrived',
  'partiallyArrived',
  'tableReady',
  'partiallySeated',
  'seated', // hidden from dropdown
  'admitted', // hidden from dropdown - set automatically via Check-in button
  'drinks',
  'appetizer',
  'entree',
  'dessert',
  'postMealDrink',
  'bottleService',
  'checkDropped',
  'paid',
  'tableKnock',
  'bussingNeeded',
  'cleared',
  'finished',
  'autoResolved',
  'canceled',
  'noShow',
] as const satisfies ServiceStatus[];
